import {
  AGRONOMY_UNIT_PRICE_MAX,
  AGRONOMY_UNIT_PRICE_MAX_DECIMALS,
  AGRONOMY_UNIT_PRICE_MIN,
} from 'appConstants';
import type { IValidationField } from 'hooks/useValidations/types';
import { getFixedT, t } from 'i18next';
import * as yup from 'yup';

const MAX_DECIMALS_REGEX = new RegExp(`^\\d+(\\.\\d{1,${AGRONOMY_UNIT_PRICE_MAX_DECIMALS}})?$`);

export default function agreementUnitPrice({ label = '' }: IValidationField) {
  const tCropForm = getFixedT(null, 'CreateAgronomyAgreement', 'CropForm');
  const rangeMessage = tCropForm('errors.unitPriceRange', {
    label,
    min: AGRONOMY_UNIT_PRICE_MIN,
    max: AGRONOMY_UNIT_PRICE_MAX,
  });

  return yup
    .number()
    .label(label)
    .typeError(t('errors.required'))
    .required()
    .min(AGRONOMY_UNIT_PRICE_MIN, rangeMessage)
    .max(AGRONOMY_UNIT_PRICE_MAX, rangeMessage)
    .test(
      'maxDigitsAfterDecimal',
      t('errors.maxDigitsAfterDecimal', { label, count: AGRONOMY_UNIT_PRICE_MAX_DECIMALS }),
      (value) => value == null || MAX_DECIMALS_REGEX.test(value.toString()),
    );
}
